import React, { useState, useEffect } from "react";
import { Col, FormGroup, Row, Pagination } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link, Navigate, useNavigate, useOutletContext } from "react-router-dom";
import { Input, PaginationItem, PaginationLink } from "reactstrap";

import TableData from "./TableData";
import { getAllParticularOwner } from "store/actions";
import { Oval } from 'react-loader-spinner'
export default function OwnedNft(props) {
  const [menu, menuopen] = useOutletContext();
  useEffect(() => {
    menu(false)
  }, [menu])
  const [page] = useState(props.data);
  const navigate = useNavigate();
  const { authToken, user, settings } = useSelector((state) => state?.Login);
  const [search, setSearch] = useState("");
  const [data, setData] = useState([]);
  const [tabs, settabs] = useState("Owned");
  const dispatch = useDispatch();
  const [soldNfts, setSoldNfts] = useState([])

  const { owners, loading } = useSelector((state) => state?.Owners);

  const Redirect = () => {
    navigate("../ownedNft/viewNft", page);
  };
  // /profile/nft/viewNft/${item?._id}   
  useEffect(() => {
    if (user?._id) {
      let data = {};
      data.owner_id = user?._id;
      dispatch(getAllParticularOwner(data));
    }
  }, [user?._id]);

  const Artisttabs = (name) => {
    settabs(name);
  };
  const [isSell, setIsSell] = useState(false)
  useEffect(() => {
    if (tabs === "Sell") {
      setIsSell(true)
    } else {
      setIsSell(false)
    }
  }, [tabs]);
  useEffect(() => {
    if (search === "" && !isSell) {
      setData(owners);
    }
    else if (search === "" && isSell) {
      setData(soldNfts);
    } else {
      if (!isSell) {
        setData(
          owners?.filter((item) => {
            return search === ""
              ? item
              : item?.nft_id?.name?.toLowerCase().includes(search.toLowerCase());
          })
        );
      } else {
        setData(
          soldNfts?.filter((item) => {
            return search === ""
              ? item
              : item?.nft_id?.name?.toLowerCase().includes(search.toLowerCase());
          })
        );
      }
    }
    // setSumOfAllSellItemPrice(
  }, [search, owners, tabs, isSell, soldNfts]);



  // pagination
  const [dataLength, setDataLength] = useState([]);
  const [dataAfterPagination, setDataAfterPagination] = useState([]);
  var [values, setValues] = useState(10);
  var [sNoValue, setSNovalue] = useState(0);
  useEffect(() => {
    let x = 0;
    if (data?.length < 9) {
      x = 1;
    } else {
      x = Math.ceil(data.length / 10);
    }
    const newLengthArray = Array.from({ length: x }, (_, index) => index + 1);
    setDataLength(newLengthArray);
  }, [data]);
  useEffect(() => {

    if (data?.length < 9) {
      setDataLength([1]);
    } else {
      const x = Math.ceil(data.length / 10);
      const newLengthArray = Array.from({ length: x }, (_, index) => index + 1);
      setDataLength(newLengthArray);
    }

  }, [data, tabs]);
  useEffect(() => {
    setDataLength([1]);
    setValues(10)

  }, [search]);
  useEffect(() => {
    let arr = [];
    setSNovalue(values - 10);
    for (let i = values - 10; i < values; i++) {
      if (data[i]) {
        arr.push(data[i]);
      }
    }

    setDataAfterPagination(arr);
  }, [values, data, dataLength, search, tabs]);
  const handlePagination = (val) => {
    let valu = 0;
    if (val === "<<") {
      valu = 10;
    } else if (val === "<") {
      valu = Math.max(0, values - 10);
    } else if (val === ">" && sNoValue / 10 < values) {
      valu = (parseInt(values / 10) + 1) * 10;
    } else if (val === ">>" && values < data.length) {
      valu = Math.ceil(data.length / 10) * 10;
    } else {
      valu = parseInt(val) * 10;
    }
    setValues(valu);
  };

  return (
    <>
      {loading &&
        <div className='loaderBoxMiane'>
          <Oval
            height={80}
            width={80}
            color="#6C63FF"
            wrapperStyle={{}}
            wrapperClass=""
            visible={true}
            ariaLabel='oval-loading'
            secondaryColor="#6C63FF"
            strokeWidth={2}
            strokeWidthSecondary={2}

          />
        </div>
      }
      <Row>
        <Col lg={12} className="mb-4">
          <div className="d-flex w-100 align-items-center justify-content-between flex-wrap">
            <h1 className="mb-0"><i onClick={menuopen} className="fa-light fa-bars-sort"></i>  Owned Artwork</h1>
          </div>
        </Col>
      </Row>
      <Row>
        <Col lg={12}>
          <div className="TabsData mt-4">
            <Row className="justify-content-between">
              <Col lg={12}>
                <div className="artTab mb-4">
                  <ul>
                    <li
                      onClick={() => Artisttabs("Owned")}
                      className={tabs === "Owned" ? "active" : ""}
                    >
                      Bought
                    </li>
                    <li
                      onClick={() => Artisttabs("Sell")}
                      className={tabs === "Sell" ? "active" : ""}
                    >
                      Sold
                    </li>
                  </ul>
                </div>
              </Col>
              <Col lg={6}>
                <FormGroup className="position-relative">
                  <Input
                    onChange={(e) => setSearch(e.target.value)}
                    className="form-control searchInput"
                    placeholder="Search"
                  />
                  <button className="btn position-absolute end-0 top-0 bottom-0 my-auto border-0">
                    <i className="fa-light fa-magnifying-glass"></i>
                  </button>
                </FormGroup>
                {/* <p className="pdecription ">Showing 350 {pageName === 'nft' ? 'NFT’s' : 'Collections'}</p> */}
              </Col>
              {/* <Col lg={4}>
                      <div className="d-flex align-item-center gap-3">
                          <Input type="select" className="form-control searchInput shadow-none">

                              <option>Low to High</option>
                              <option>Low to High</option>
                              <option>Low to High</option>

                          </Input>
                          <Input type="select" className="form-control searchInput shadow-none">
                              <option>WEEKLY</option>
                              <option>DAILY</option>
                          </Input>
                          <button className="btn border-0 clearfilter px-0">
                              <i className="fa-solid fa-filter-circle-xmark"></i>
                          </button>
                      </div>
                  </Col> */}
            </Row>
            <div className="table-responsive tableNft">
              <table>
                <thead>
                  <tr>
                    <td className="text-center">No.</td>
                    <td>Artwork Name</td>
                    {/* <td className="text-center">Total Owners</td> */}
                    <td className="text-center">Total Artworks</td>
                    <td className="text-center">Total Minted</td>
                    <td className="text-center">Status</td>
                    <td className="text-center">Owned</td>
                    {/* auction/fixed */}
                    {/* <td className="text-center">Status</td> */}
                    <td className="text-center">Action</td>
                  </tr>
                </thead>

                <tbody>
                  {dataAfterPagination.length > 0 ? (
                    <>
                      {dataAfterPagination.map((item, index) => (
                        <tr key={index}>
                          <td className="text-center">{(sNoValue += 1)}</td>
                          <td>
                            <img
                              className="nftimge"
                              alt=""
                              src={(user?._id && user?._id === item?.owner_id?._id && item?.saleType === "bid" && item?.ownership_status !== "Completed") ? item?.nft_id?.image_id?.image?.link : item?.nft_id?.image_id?.image?.water_mark_image_link ? item?.nft_id?.image_id?.image?.water_mark_image_link : item?.nft_id?.image_id?.image?.link}
                            />{" "}
                            {item?.nft_id?.name}
                          </td>
                          <td className="text-center">
                            {item?.available_copies}
                          </td>
                          <td className="text-center">
                            {item?.nft_id?.noofcopies}
                          </td>
                          <td className="text-center">
                            {/* <td className="text-center"> <button className={"statusbtt  " + (item?.onSale === true) ? 'onsale':'offsale' }>{item?.onSale === "true" ? 'On Sale' : "Off Sale"} </button></td>  */}
                            {item?.onSale === false ? <button className="statusbtt pendingstatus text-capitalize">Off Sale</button> : <button className="statusbtt onsale">On Sale</button>}
                          </td>
                          <td className="text-center">
                            {item?.ownership_status
                              ? item?.ownership_status
                              : "Pending"}
                          </td>
                          {/* <td className="text-center">
                      {pagesoldbyartist === 'soldbyartist' ? (<button className="statusbtt pendingstatus">Pending</button>) : (
                          <button className="statusbtt onsale">On Sale</button>
                      )}
                  </td> */}
                          {/* <td className="text-center"> <button className={"statusbtt  " + (item?.onSale === true) ? 'onsale':'offsale' }>{item?.onSale === "true" ? 'On Sale' : "Off Sale"} </button></td> */}
                          <td className="text-center">
                            {/* <button className="btn border-0"><i className="fa-regular fa-pen-to-square"></i></button> */}
                            <Link className="btn border-0 " to={`/profile/ownedNft/viewNft/${item?.sellItem_id}`} state={item?.ownership_status}> <i className="fa-regular fa-eye"></i></Link>
                            {/* <Link className="btn border-0 " to={`/profile/nft/viewNft/${item?._id}`}><i className="fa-regular fa-eye"></i></Link> */}
                          </td>
                        </tr>
                      ))}
                    </>
                  ) : (
                    <>
                      <tr>
                        <td colSpan={7}>
                          <div className="text-center d-grid justify-content-center dataNotFound py-5">
                            <img src={"/images/svg/mpdatanft.svg"} className="mb-4" alt="Create collection" />
                            <h3>No Digital Artwork Available</h3>
                          </div>
                        </td>
                      </tr>
                    </>
                  )
                  }
                </tbody>
              </table>
            </div>
          </div>
        </Col>
        {dataAfterPagination.length > 0 && <Col lg={12} className="text-end">
          <Pagination
            className="paginationNew"
            aria-label="Page  navigation example"
          >
            {values > 10 && (
              <div>
                <PaginationItem>
                  <PaginationLink
                    first
                    href="#"
                    onClick={() => handlePagination("<<")}
                  />
                </PaginationItem>
                <PaginationItem>
                  <PaginationLink
                    href="#"
                    previous
                    onClick={() => handlePagination("<")}
                  />
                </PaginationItem>
              </div>
            )}
            {dataLength &&
              dataLength.map((item) => (
                <PaginationItem
                  className={parseInt(item) === values / 10 ? "active" : ""}
                >
                  <PaginationLink
                    href="#"
                    onClick={() => handlePagination(item)}
                  >
                    {item}
                  </PaginationLink>
                </PaginationItem>
              ))}
            {/* <PaginationItem>
                                                <PaginationLink href="#">
                                                    2
                                                </PaginationLink>
                                            </PaginationItem>
                                            <PaginationItem disabled>
                                                <PaginationLink href="#">
                                                    3
                                                </PaginationLink>
                                            </PaginationItem>
                                            <PaginationItem>
                                                <PaginationLink href="#">
                                                    4
                                                </PaginationLink>
                                            </PaginationItem>
                                            <PaginationItem> */}
            {/* <PaginationLink href="#">
                                                    5
                                                </PaginationLink> */}
            {/* </PaginationItem> */}
            {values < data.length && (
              <div>
                <PaginationItem>
                  <PaginationLink
                    href="#"
                    next
                    onClick={() => handlePagination(">")}
                  />
                </PaginationItem>
                <PaginationItem>
                  <PaginationLink
                    href="#"
                    last
                    onClick={() => handlePagination(">>")}
                  />
                </PaginationItem>
              </div>
            )}
          </Pagination>
        </Col>}

      </Row>
    </>
  );
}
